/**
 * @generated SignedSource<<408c9616b396638db0b62d0b815d2e20>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedContactDealerButton_item$data = {
  readonly priceType: ReadonlyArray<{
    readonly textType: string | null;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"SharedContactDealerWrapper_item">;
  readonly " $fragmentType": "PdpSharedContactDealerButton_item";
};
export type PdpSharedContactDealerButton_item$key = {
  readonly " $data"?: PdpSharedContactDealerButton_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedContactDealerButton_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedContactDealerButton_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_item"
    },
    {
      "alias": "priceType",
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        },
        {
          "kind": "Literal",
          "name": "catchNonFatalErrors",
          "value": false
        },
        {
          "kind": "Literal",
          "name": "isTrade",
          "value": false
        }
      ],
      "concreteType": "ItemDisplayPriceType",
      "kind": "LinkedField",
      "name": "displayPrice",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "textType",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "e692a15322527e952415a0ecb3a8e21f";

export default node;
